import React from 'react'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import './FileAttachmentList.css'

export const FileAttachmentList = ({ files, onRemove }) => {
  if (!files || files.length === 0) {
    return null
  }

  return (
    <div className='file-attachment-list'>
      <h4>Attachments</h4>
      <div className='attachment-items'>
        {files.map((file, index) => (
          <Card key={index} className='attachment-item'>
            <div className='attachment-content'>
              <span className='attachment-name' title={file.name}>
                {file.name}
              </span>
              <Button
                icon='pi pi-times'
                className='p-button-rounded p-button-danger p-button-outlined attachment-remove'
                onClick={() => onRemove(file, index)}
                aria-label='Remove file'
              />
            </div>
          </Card>
        ))}
      </div>
    </div>
  )
}
